import project from "./project";

const standardSortOptions = [
  { label: "Lowest cost", value: "lowest-cost" },
  { label: "Highest graduation rate", value: "gradRate" },
  { label: "Highest earning", value: "highest-earning" },
  { label: "Shortest", value: "shortest" },
  { label: "Closest", value: "closest" },
];

const config = {
  skillup: standardSortOptions,
  wherewego: [...standardSortOptions, { label: "Newest", value: "newest" }],
};

export default config[project];
